module.exports = __webpack_public_path__ + "img/icon_5.a280e71.svg";